




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'VerifiableAttribute',
})
export default class extends GiganautVue {

	@Prop({required: true})
	isVerified: boolean;

	get color() {
		if (this.isVerified){
            return "green"
        }
        return "orange"
	}

  get icon() {
		if (this.isVerified){
            return this.IconConstants.Verified;
        }
        return this.IconConstants.Unverified;
	}

  get text() {
		if (this.isVerified){
            return "Verified"
        }
        return "Unverified"
	}
}
